const WebinarRegistrationPage = () => import('@/pages/webinar/WebinarRegistrationPage.vue');

const routes = [
  {
    path: '/webinar-registration/',
    name: 'WebinarRegistration',
    meta: {
      title: 'Webinar Registration',
    },
    component: WebinarRegistrationPage,
  },
];

export default routes;
